import $ from 'jquery';
import 'slick-carousel';

export default function initM119() {
    $(function () {
        if ($('.module-m119').length > 0) {
            $('.module-m119').each(function () {
                let $module = $(this);
                $module.find('.module-m119-items').slick({
                    arrows: false,
                    dots: false,
                    infinite: true,
                    speed: 5000,
                    slidesToShow: 6.5,
                    slidesToScroll: 1,
                    swipe: false,
                    autoplay: true,
                    autoplaySpeed: 0,
                    cssEase: 'linear',
                    responsive: [
                        {
                            breakpoint: 2100,
                            settings: {
                                slidesToShow: 5.5,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 1620,
                            settings: {
                                slidesToShow: 4.5,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3.5,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 4.5,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3.5,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 2.5,
                                slidesToScroll: 1
                            }
                        },
                        {
                            breakpoint: 420,
                            settings: {
                                slidesToShow: 1.75,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });
            });
        }
    });
}
